import { Skeleton } from "antd";
import { SkeletonProps } from "antd/lib";

import style from "./AntSkeleton.module.scss";

const AntSkeleton = (props: SkeletonProps) => {
  return (
    <Skeleton
      round={true}
      active={true}
      className={style.skeleton}
      {...props}
    />
  );
};

AntSkeleton.Image = Skeleton.Image;

export default AntSkeleton;
